export const ActionType = {
  GET_DARKMODE: 'GET_DARKMODE',
  GET_LANGUAGE: 'GET_LANGUAGE',
  GET_CHAIN: 'GET_CHAIN',
  GET_NETWORK: 'GET_NETWORK',
};

const coreui = (
  state = {
    language: null,
    darkmode: null,
    chain: { viewTrans: () => {}, viewTokenID: () => {} },
    network: { isOpenSwitch: false },
  },
  { type, data },
) => {
  switch (type) {
    case ActionType.GET_DARKMODE:
      return { ...state, darkmode: data };
    case ActionType.GET_LANGUAGE:
      return { ...state, language: data };
    case ActionType.GET_CHAIN:
      return { ...state, chain: data };
    case ActionType.GET_NETWORK:
      return { ...state, network: data };
    default:
      return state;
  }
};

export default coreui;
